import { render, staticRenderFns } from "./SendTicketModalFront.vue?vue&type=template&id=9ca7126a"
import script from "./SendTicketModalFront.vue?vue&type=script&setup=true&lang=js"
export * from "./SendTicketModalFront.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports